import { render, staticRenderFns } from "./ResultadoExame.vue?vue&type=template&id=2484e5c0&scoped=true"
import script from "./ResultadoExame.vue?vue&type=script&lang=js"
export * from "./ResultadoExame.vue?vue&type=script&lang=js"
import style0 from "./ResultadoExame.vue?vue&type=style&index=0&id=2484e5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484e5c0",
  null
  
)

export default component.exports